import { Form, Formik } from 'formik';
import { CheckBox, TextArea, TextBox } from '../../shared/controls/form';
import { useSelector } from 'react-redux';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import { validationSchemaLead } from './validationSchema';
import SelectBox from '../../shared/controls/form/selectBox';
import { formatUSCurrency } from '../../shared/constants';

const LeadForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  handleChangeCheckbox,
  refs,
}) => {
  const owner = useSelector(getActiveOwners);
  const revenueTypeDropdown = useSelector(getGenericMasterFilteredListByKey('RevenueType'));
  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));

  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const timeZone = useSelector(getGenericMasterFilteredListByKey('TimeZone'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaLead}
    >
      <Form>
        <div className="collapse_card mb-3">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row gx-3">
              <div className="col-12 col-sm-12 col-md-6">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                      Company Information
                    </label>
                  </div>
                  <div className="leadcontent leadDetailInfo leadHt1">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12" ref={refs?.companyName}>
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Company Name'}
                            name={'companyName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Company Name'}
                            value={formData?.companyName}
                            handleChange={handleChangeForm}
                            maxLength={100}
                            errormsg={errormsg?.companyName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label={'Phone'}
                            name={'phone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Phone Number'}
                            value={formData?.phone}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.phone}
                            disabled={formData?.type === 'view'}
                            maxLength={15}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Alternate Phone'}
                            name={'alternatePhone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Phone Number 2'}
                            value={formData?.alternatePhone}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.alternatePhone}
                            disabled={formData?.type === 'view'}
                            maxLength={15}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Time Zone'}
                            name={'timeZoneId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.timeZone || '--'
                                : formData?.timeZone || 'Select Time Zone'
                            }
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.timeZoneId}
                            handleSelect={handleChange}
                            options={timeZone}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.timeZoneId}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container LinkDes">
                          <TextBox
                            label={'Company LinkedIn'}
                            name={'companyLinkedIn'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Company LinkedIn'
                            }
                            value={formData?.companyLinkedIn}
                            handleChange={handleChangeForm}
                            maxLength={200}
                            errormsg={errormsg?.companyLinkedIn}
                            disabled={formData?.type === 'view'}
                            fieldType="link"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Website'}
                            name={'website'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Company Website'}
                            value={formData?.website}
                            handleChange={handleChangeForm}
                            maxLength={200}
                            errormsg={errormsg?.website}
                            disabled={formData?.type === 'view'}
                            fieldType="link"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Annual Revenue'}
                            name={'annualRevenue'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Annual Revenue'}
                            value={
                              formData?.type === 'view'
                                ? formatUSCurrency(formData?.annualRevenue)
                                : (formData?.annualRevenue ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={16}
                            errormsg={errormsg?.annualRevenue}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Written Premium'}
                            name={'writtenPremium'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Written Premium'}
                            value={
                              formData?.type === 'view'
                                ? formatUSCurrency(formData?.writtenPremium)
                                : (formData?.writtenPremium ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={16}
                            errormsg={errormsg?.writtenPremium}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Revenue Type'}
                            name={'revenueTypeId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.revenueType || '--'
                                : formData?.revenueType || 'Select Revenue Type'
                            }
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.revenueTypeId}
                            handleSelect={handleChange}
                            options={revenueTypeDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.revenueTypeId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                        <div className="input-container showarrow">
                          <TextBox
                            label={'No. of Employees'}
                            name={'noOfEmployees'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter No. of Employees'
                            }
                            value={formData?.noOfEmployees}
                            handleChange={handleChangeForm}
                            maxLength={10}
                            errormsg={errormsg?.noOfEmployees}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/contactInfo.svg" alt="" />
                      Contact Information
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo leadHt2">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Salutation'}
                            name={'salutationId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.salutation || '--'
                                : formData?.salutation || 'Select Salutation'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.salutationId}
                            handleSelect={handleChange}
                            options={salutation}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.salutationId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'First Name'}
                            name={'firstName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter First Name'}
                            value={formData?.firstName}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.firstName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Middle Name'}
                            name={'middleName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Middle Name'}
                            value={formData?.middleName}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.middleName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-12 col-lg-12" ref={refs?.lastName}>
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Last Name'}
                            name={'lastName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Last Name'}
                            value={formData?.lastName}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.lastName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label={'Title'}
                            name={'title'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Title'}
                            value={formData?.title}
                            handleChange={handleChangeForm}
                            maxLength={100}
                            errormsg={errormsg?.title}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Email'}
                            name={'email'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Email'}
                            value={formData?.email}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.email}
                            disabled={formData?.type === 'view'}
                            fieldType="email"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Secondary Email'}
                            name={'secondaryEmail'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Secondary Email'}
                            value={formData?.secondaryEmail}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.secondaryEmail}
                            disabled={formData?.type === 'view'}
                            fieldType="email"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Direct Phone'}
                            name={'directPhone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Direct Phone'}
                            value={formData?.directPhone}
                            handleChange={handleChangeForm}
                            maxLength={15}
                            errormsg={errormsg?.directPhone}
                            disabled={formData?.type === 'view'}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Mobile'}
                            name={'mobile'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Mobile'}
                            value={formData?.mobile}
                            handleChange={handleChangeForm}
                            maxLength={15}
                            errormsg={errormsg?.mobile}
                            disabled={formData?.type === 'view'}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container LinkDes">
                          <TextBox
                            label={'Contact LinkedIn'}
                            name={'contactLinkedIn'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Contact LinkedIn'
                            }
                            value={formData?.contactLinkedIn}
                            handleChange={handleChangeForm}
                            maxLength={200}
                            errormsg={errormsg?.contactLinkedIn}
                            disabled={formData?.type === 'view'}
                            fieldType="link"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-3" id="flex-clumn">
                        <div className="input-container optcolor">
                          <CheckBox
                            label={'Email Opt Out'}
                            name={'emailOptOut'}
                            checked={formData?.emailOptOut}
                            handleChange={handleChangeCheckbox}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                      General Information
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo leadHt3">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Business Type'}
                            name={'businessType'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Business Type'}
                            value={formData?.businessType}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.businessType}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12" ref={refs?.industryId}>
                        <div className="input-container">
                          <SelectBox
                            label={'Industry'}
                            name={'industryId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.industry || '--'
                                : formData?.industry || 'Select Industry'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.industryId}
                            handleSelect={handleChange}
                            options={industryTypeDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.industryId}
                          />
                        </div>
                      </div>
                      {formData?.industry === 'Healthcare' && (
                        <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                          <div className="input-container">
                            <TextBox
                              label={'No. of Beds'}
                              name={'noOfBeds'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter No. of Beds'}
                              value={formData?.noOfBeds}
                              handleChange={handleChangeForm}
                              maxLength={250}
                              errormsg={errormsg?.noOfBeds}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Line of Business'}
                            name={'lineOfBusiness'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Line of Business'
                            }
                            value={formData?.lineOfBusiness}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.lineOfBusiness}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div
                        className="col-12 col-sm-12 col-md-12 col-lg-12"
                        ref={refs?.leadSourceId}
                      >
                        <div className="input-container">
                          <SelectBox
                            label={'Lead Source'}
                            name={'leadSourceId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.leadSource || '--'
                                : formData?.leadSource || 'Select Lead Source'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.leadSourceId}
                            handleSelect={handleChange}
                            options={leadSourceDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.leadSourceId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12" ref={refs?.sourceName}>
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Source Name'}
                            name={'sourceName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Source Name'}
                            value={formData?.sourceName}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.sourceName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Other Source Name'}
                            name={'otherSourceName'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Other Source Name'
                            }
                            value={formData?.otherSourceName}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.otherSourceName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Lead Owner'}
                            name={'ownerId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.owner || '--'
                                : formData?.owner || 'Select Lead Owner'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.ownerId}
                            handleSelect={handleChange}
                            options={owner}
                            optionKeys={['userId', 'display_name']}
                            errormsg={errormsg?.ownerId}
                            nameFormatter={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/addressInfo.svg" alt="" />
                      Address Information
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo leadHt4">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Street'}
                            name={'street'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Street'}
                            value={formData?.street}
                            handleChange={handleChangeForm}
                            maxLength={100}
                            errormsg={errormsg?.street}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'City'}
                            name={'city'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                            value={formData?.city}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.city}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'State'}
                            name={'state'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                            value={formData?.state}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            errormsg={errormsg?.state}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Zip Code'}
                            name={'zipCode'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Zip Code'}
                            value={formData?.zipCode}
                            handleChange={handleChangeForm}
                            maxLength={10}
                            minLength={2}
                            errormsg={errormsg?.zipCode}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-container">
                          <TextBox
                            label={'Country'}
                            name={'country'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                            value={formData?.country}
                            handleChange={handleChangeForm}
                            maxLength={50}
                            minLength={2}
                            errormsg={errormsg?.country}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox  mb-0">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/notesIcon.svg" alt="" />
                      Notes & Tech Details
                    </label>
                  </div>

                  <div className="leadcontent pd_card leadDetailInfo notesLabel">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Description'}
                            name={'description'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                            value={formData?.description}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.description}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Technology Details'}
                            name={'technologyDetails'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Technology Details'
                            }
                            value={formData?.technologyDetails}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.technologyDetails}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default LeadForm;
